import React from 'react'
import PropTypes from 'prop-types'

const GeralVisionIcon = ({className}) =>
(
  <svg className={className} width="8" height="13" viewBox="0 0 8 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.51321 1.22533L3.93351 6.232C3.81896 6.392 3.81831 6.60867 3.9322 6.76867L7.48572 11.776C7.70041 12.078 7.48834 12.5 7.12245 12.5H5.14965C5.00565 12.5 4.87081 12.43 4.78638 12.3107L0.851906 6.76733C0.738669 6.608 0.738669 6.39267 0.851906 6.23267L4.78638 0.689333C4.87081 0.570667 5.00565 0.5 5.14965 0.5L7.1506 0.5C7.5178 0.5 7.72921 0.923333 7.51321 1.22533" fill="currentColor"/>
  </svg>


)

GeralVisionIcon.propTypes = {
  className: PropTypes.string
}

export default GeralVisionIcon
